export { ViewHeaderBackground, ViewHeaderType } from './view-header.component';
